import React from "react"

interface LogoProps {
  size?: "small" | "large" | "default"
  className?: string
}

export const Logo = ({ size = "default", className = "" }: LogoProps) => {
  const sizeClasses = {
    small: "text-lg",
    default: "text-2xl",
    large: "text-3xl",
  }

  return (
    <span
      className={`${sizeClasses[size]} font-bold bg-gradient-to-r from-green-400 via-blue-500 to-purple-600 bg-clip-text text-transparent select-none ${className}`}
    >
      Aurora Forecaster
    </span>
  )
}